import { BiMailSend } from "react-icons/bi";
import { HiMail, HiPhone, HiLocationMarker } from "react-icons/hi";
import { FaGitlab, FaGithub, FaLinkedin, FaTelegram } from "react-icons/fa";

const Contact = () => {
  return (
    <div name="contact" className="w-full min-h-screen bg-[#0a192f] py-20">
      <div className="max-w-[1200px] mx-auto px-8">
        <div className="pb-12">
          <h2 className="text-4xl sm:text-5xl font-bold inline-block border-b-4 border-cyan-600 text-gray-300">
            Get In Touch
          </h2>
          <p className="text-[#8892b0] text-lg mt-4">
            Let's discuss your next project or opportunity
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-12">
          <div className="space-y-8">
            <div>
              <h3 className="text-2xl font-bold text-white mb-4">
                Contact Information
              </h3>
              <p className="text-[#8892b0] text-lg mb-6">
                I'm always open to discussing new projects, creative ideas, or
                opportunities to be part of your vision. Feel free to reach out
                through any of these channels.
              </p>
            </div>

            <div className="space-y-4">
              <a
                href="mailto:bk14drobs@gmail.com"
                className="flex items-center gap-4 p-4 bg-[#112240] rounded-lg border border-cyan-600 border-opacity-20 hover:border-opacity-50 transition-all duration-300 group"
              >
                <div className="p-3 bg-cyan-600 bg-opacity-20 rounded-lg group-hover:bg-opacity-30 transition-all">
                  <HiMail className="text-2xl text-cyan-500" />
                </div>
                <div>
                  <p className="text-white font-semibold">Email</p>
                  <p className="text-[#8892b0]">bk14drobs@gmail.com</p>
                </div>
              </a>

              <div className="flex items-center gap-4 p-4 bg-[#112240] rounded-lg border border-cyan-600 border-opacity-20">
                <div className="p-3 bg-cyan-600 bg-opacity-20 rounded-lg">
                  <HiPhone className="text-2xl text-cyan-500" />
                </div>
                <div>
                  <p className="text-white font-semibold">Phone</p>
                  <p className="text-[#8892b0]">+251 913 21 77 67</p>
                </div>
              </div>

              <div className="flex items-center gap-4 p-4 bg-[#112240] rounded-lg border border-cyan-600 border-opacity-20">
                <div className="p-3 bg-cyan-600 bg-opacity-20 rounded-lg">
                  <HiLocationMarker className="text-2xl text-cyan-500" />
                </div>
                <div>
                  <p className="text-white font-semibold">Location</p>
                  <p className="text-[#8892b0]">
                    Addis Ababa, Ethiopia (Open to Remote)
                  </p>
                </div>
              </div>
            </div>

            <div>
              <h4 className="text-xl font-bold text-white mb-4">
                Connect With Me
              </h4>
              <div className="flex gap-4">
                <a
                  href="https://github.com/Beki-D"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="p-4 bg-[#112240] rounded-lg border border-cyan-600 border-opacity-20 hover:border-opacity-50 hover:bg-cyan-600 hover:bg-opacity-10 transition-all duration-300"
                >
                  <FaGithub className="text-2xl text-cyan-500" />
                </a>
                <a
                  href="https://gitlab.com/Beki-D"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="p-4 bg-[#112240] rounded-lg border border-cyan-600 border-opacity-20 hover:border-opacity-50 hover:bg-cyan-600 hover:bg-opacity-10 transition-all duration-300"
                >
                  <FaGitlab className="text-2xl text-cyan-500" />
                </a>
                <a
                  href="https://linkedin.com/in/beki-d-abate-818222233"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="p-4 bg-[#112240] rounded-lg border border-cyan-600 border-opacity-20 hover:border-opacity-50 hover:bg-cyan-600 hover:bg-opacity-10 transition-all duration-300"
                >
                  <FaLinkedin className="text-2xl text-cyan-500" />
                </a>
                <a
                  href="https://t.me/bk25119"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="p-4 bg-[#112240] rounded-lg border border-cyan-600 border-opacity-20 hover:border-opacity-50 hover:bg-cyan-600 hover:bg-opacity-10 transition-all duration-300"
                >
                  <FaTelegram className="text-2xl text-cyan-500" />
                </a>
              </div>
            </div>
          </div>

          <div>
            <form
              method="POST"
              action="https://getform.io/f/d79267af-9730-4cdf-8628-189d5c6d5d71"
              className="bg-[#112240] p-8 rounded-lg border border-cyan-600 border-opacity-20 space-y-4"
            >
              <div>
                <label className="block text-white font-semibold mb-2">
                  Your Name
                </label>
                <input
                  className="w-full bg-[#0a192f] text-gray-100 p-4 rounded-lg border border-cyan-600 border-opacity-20 focus:border-opacity-50 focus:outline-none transition-all"
                  type="text"
                  placeholder="John Doe"
                  name="name"
                  required
                />
              </div>

              <div>
                <label className="block text-white font-semibold mb-2">
                  Your Email
                </label>
                <input
                  className="w-full bg-[#0a192f] text-gray-100 p-4 rounded-lg border border-cyan-600 border-opacity-20 focus:border-opacity-50 focus:outline-none transition-all"
                  type="email"
                  placeholder="john@example.com"
                  name="email"
                  required
                />
              </div>

              <div>
                <label className="block text-white font-semibold mb-2">
                  Subject
                </label>
                <input
                  className="w-full bg-[#0a192f] text-gray-100 p-4 rounded-lg border border-cyan-600 border-opacity-20 focus:border-opacity-50 focus:outline-none transition-all"
                  type="text"
                  placeholder="Project Discussion"
                  name="subject"
                />
              </div>

              <div>
                <label className="block text-white font-semibold mb-2">
                  Message
                </label>
                <textarea
                  className="w-full bg-[#0a192f] text-gray-100 p-4 rounded-lg border border-cyan-600 border-opacity-20 focus:border-opacity-50 focus:outline-none transition-all resize-none"
                  name="message"
                  rows="6"
                  placeholder="Tell me about your project..."
                  required
                ></textarea>
              </div>

              <button
                type="submit"
                className="w-full text-white bg-cyan-600 hover:bg-cyan-700 hover:shadow-lg hover:shadow-cyan-600/50 transition-all duration-300 group px-6 py-4 flex items-center justify-center gap-3 rounded-lg font-semibold text-lg"
              >
                Send Message
                <span className="group-hover:translate-x-2 transition-transform duration-300">
                  <BiMailSend className="text-2xl" />
                </span>
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;
